// @flow
import type {MarkdocTagRegistration} from 'docs/markdoc';

export const File: MarkdocTagRegistration = {
  tag: 'file',
  component: 'File',
  attributes: {
    language: {type: String},
    filename: {type: String},
    downloadOnly: {type: Boolean},
    steps: {type: Array},
    when: {type: Object},
  },
};
